<template>
  <div class="template-library-wrapper" v-if="!isLoadingFeatures">
    <component :is="templateLibraryComponent" v-aha-emit-action.view />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('featureToggles', [
      'canUseNewTemplateLibrary',
      'isLoadingFeatures',
    ]),
    templateLibraryComponent() {
      return this.canUseNewTemplateLibrary
        ? () => import('./v2/TemplateLibrary.js')
        : () => import('./TemplateLibraryGlobal.vue')
    },
  },
}
</script>
